import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';

// components
import Root from './Root';
import PrivateRoute from './PrivateRoute';

// lazy load all the views
// auth
const Login = React.lazy(() => import('../pages/auth/Login'));
const SignUp = React.lazy(() => import('../pages/auth/SignUp'));
const ForgetPassword = React.lazy(() => import('../pages/auth/ForgetPassword'));
const Confirm = React.lazy(() => import('../pages/auth/Confirm'));
const Logout = React.lazy(() => import('../pages/auth/Logout'));

// home
const Home = React.lazy(() => import('../pages/Home'));

// landings
const Terms = React.lazy(() => import('../pages/other/Terms'));
const Privacy = React.lazy(() => import('../pages/other/Privacy'));
const App = React.lazy(() => import('../pages/landings/App'));
const Web = React.lazy(() => import('../pages/landings/Web'));
const Automation = React.lazy(() => import('../pages/landings/Automation'));
const Ai = React.lazy(() => import('../pages/landings/AI'));
const LiferayCloud = React.lazy(() => import('../pages/landings/Liferay/LiferayCloud'));
const GoogleCloudPlatform = React.lazy(() => import('../pages/landings/Liferay/GoogleCloudPlatform'));
const CloudMigration = React.lazy(() => import('../pages/landings/CloudMigration'));
const Aws = React.lazy(() => import('../pages/landings/Liferay/Aws'));
const Saas = React.lazy(() => import('../pages/landings/Liferay/Saas'));
const Liferay = React.lazy(() => import('../pages/landings/Liferay/Liferay'));
const Startup = React.lazy(() => import('../pages/landings/Startup'));
const Software = React.lazy(() => import('../pages/landings/Software'));
const Agency = React.lazy(() => import('../pages/landings/Agency'));
const Coworking = React.lazy(() => import('../pages/landings/Coworking'));
const Crypto = React.lazy(() => import('../pages/landings/Crypto'));
const Marketing = React.lazy(() => import('../pages/landings/Marketing'));
const Portfolio = React.lazy(() => import('../pages/landings/Portfolio'));

// pages
const Dashboard = React.lazy(() => import('../pages/other/account/Dashboard'));
const Settings = React.lazy(() => import('../pages/other/account/Settings'));
const Blog = React.lazy(() => import('../pages/other/Blog'));
const BlogPost = React.lazy(() => import('../pages/other/BlogPost'));
const Company = React.lazy(() => import('../pages/other/Company'));
const Contact = React.lazy(() => import('../pages/other/Contact'));
const Support = React.lazy(() => import('../pages/other/Support'));
const About = React.lazy(() => import('../pages/other/Company/About'));
const Career = React.lazy(() => import('../pages/other/Career'));
const Pricing = React.lazy(() => import('../pages/other/Pricing'));
const PortfolioGrid = React.lazy(() => import('../pages/other/portfolio/PortfolioGrid'));
const PortfolioMasonry = React.lazy(() => import('../pages/other/portfolio/PortfolioMasonry'));
const PortfolioItem = React.lazy(() => import('../pages/other/portfolio/PortfolioItem'));
const HelpDesk = React.lazy(() => import('../pages/other/HelpDesk'));

// docs
const Introduction = React.lazy(() => import('../pages/docs/Introduction'));
const QuickStart = React.lazy(() => import('../pages/docs/QuickStart'));
const Customization = React.lazy(() => import('../pages/docs/Customization'));
const Routing = React.lazy(() => import('../pages/docs/Routing'));
const CodeSpliting = React.lazy(() => import('../pages/docs/CodeSpliting'));
const ChangeLog = React.lazy(() => import('../pages/docs/ChangeLog'));
const Colors = React.lazy(() => import('../pages/docs/Colors'));
const Typography = React.lazy(() => import('../pages/docs/Typography'));
const Bootstrap = React.lazy(() => import('../pages/docs/Bootstrap'));
const Custom = React.lazy(() => import('../pages/docs/Custom'));
const Plugins = React.lazy(() => import('../pages/docs/Plugins'));
const Navbars = React.lazy(() => import('../pages/docs/Navbars'));
const Heros = React.lazy(() => import('../pages/docs/Heros'));
const loading = () => <div className=""></div>;
const LoadComponent = ({
  component: Component
}) => <Suspense fallback={loading()}>
        <Component />
    </Suspense>;
const AllRoutes = () => {
  return useRoutes([{
    // root route
    path: '/',
    element: <Root />
  }, {
    // public routes
    path: '/',
    children: [ {
      path: 'home',
      element: <LoadComponent component={Home} />
    }, {
      path: 'about',
      element: <LoadComponent component={Company} />
    }, {
      path: 'contact',
      element: <LoadComponent component={Contact} />
    }, {
      path: 'support',
      element: <LoadComponent component={Support} />
    }, {
      path: 'liferay',
      element: <LoadComponent component={Liferay} />
    }, {
      path: 'app',
      element: <LoadComponent component={App} />
    }, {
      path: 'web',
      element: <LoadComponent component={Web} />
    }, {
      path: 'automation',
      element: <LoadComponent component={Automation} />
    }, {
      path: 'ai',
      element: <LoadComponent component={Ai} />
    }, {
      path: 'liferay-cloud',
      element: <LoadComponent component={LiferayCloud} />
    }, {
      path: 'gcp',
      element: <LoadComponent component={GoogleCloudPlatform} />
    }, {
      path: 'aws',
      element: <LoadComponent component={Aws} />
    }, {
      path: 'cloud-migration',
      element: <LoadComponent component={CloudMigration} />
    }, {
      path: 'terms',
      element: <LoadComponent component={Terms} />
    }, {
      path: 'privacy',
      element: <LoadComponent component={Privacy} />
    }]
  }]);
};
export default AllRoutes;

